<template>
  <GenericStep v-bind="$attrs">
    <PersonalOverviewCard
      class="mb-4"
      :item="peParty.overview"
    />
  </GenericStep>
</template>

<script>
import { cloneDeep, isEqual, pick } from 'lodash'
import { mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'
import PersonalOverviewCard from '@/components/Party/PartyEdit/SectionCards/OverviewCards/PersonalOverviewCard.vue'

export default {
  name: 'PersonalOverviewStep',

  components: {
    GenericStep,
    PersonalOverviewCard,
  },

  inheritAttrs: false,

  data () {
    return {
      hasChanged: false,
      originalData: null,
    }
  },

  computed: {
    relevantFields () {
      return pick(
        this.peParty.overview, [
          'experienced_labor_violation_us',
          'fear_returning_home_country',
          'forced_sexual_encounters',
          'forced_to_work_against_will',
          'hrifa_eligibility',
          'mistreated_by_coyote_in_transit',
          'nacara_eligibility',
          'national_of_tps_designated_country',
          'suffered_mental_harm',
          'suffered_physical_harm_home_country',
          'us_military_service',
          'victim_of_dv_abuse_by_relative_childhood',
          'victim_of_dv_us_usc_relative',
          'victim_of_ucrime_us',
          'notes',
        ]
      )
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peParty',
    ]),
  },

  watch: {
    relevantFields (value) {
      if (!this.hasChanged && !isEqual(value, this.originalData)) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },
  },

  created () {
    this.originalData = cloneDeep(this.relevantFields)
  },
}
</script>
